import { Link } from '@tanstack/react-router';
import { Eye } from 'lucide-react';
import { buttonVariants } from '@/components/ui/button';
import { cn } from '@/lib/utils';
import type { PcmpRequestQueueItem } from '../../types/pcmpRequest.types';
import { PcmpHoldActionButtons } from '../PcmpHoldActions/PcmpHoldActionButtons';

/** What a request screen row offers: hold or release, and the proposal. */
export function PcmpRequestRowActions({ item }: { item: PcmpRequestQueueItem }) {
  return (
    <>
      <PcmpHoldActionButtons
        proposalId={item.proposalId}
        refNo={item.refNo}
        canHold={item.canHold}
        canRelease={item.canRelease}
        hold={item.hold}
        className="flex-nowrap"
      />
      <Link
        to="/pcmp/proposals/$proposalId"
        params={{ proposalId: item.proposalId }}
        className={cn(buttonVariants({ variant: 'outline', size: 'sm' }), 'gap-1.5')}
      >
        <Eye className="size-3.5" />
        View
      </Link>
    </>
  );
}
